import { useRouter } from "next/router";

import { storeEvent } from "_analytics/index";

import Presentation from "./presentation";

const formatTabList = ( list = [] ) => {
	const formattedTabList =  list.map ( item => ( { value: item.apiEndpoint, label: item.displayName } ) );

	return formattedTabList;
};

const GamePage = props => {
	const router = useRouter ();

	const onChangeTab = newValue => {
		storeEvent ( "Tab", "tab_clicked", newValue );
		router.push ( `/game/${ props?.gameDetails.id }/${ props?.search_query }?tab=${ newValue }` );
	};

	return (
		<Presentation
			activeTab    = { props?.tab }
			data         = { props?.initialData }
			gameDetails  = { props?.gameDetails }
			onChangeTab  = { onChangeTab }
			search_query = { props?.search_query }
			tabList      = { formatTabList ( props?.tabs ) }
		/>
	);
};

export default GamePage;